// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import { LoginPage } from "./"

export default {
  path: "auth",
  name: "Auth",
  childRoutes: [{ path: "login", name: "Login page", component: LoginPage }],
}



// WEBPACK FOOTER //
// ./src/features/auth/route.js